export enum DeliveryType {
  CIF = "CIF",
  FOB = "FOB",
}

export const deliveryOptions = [
  { value: DeliveryType.CIF, label: "CIF" },
  { value: DeliveryType.FOB, label: "FOB" },
];
